import type { Maybe } from '@adornis/base/utilTypes';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element';
import { RXController } from '@adornis/chemistry/controllers/RXController';
import { css } from '@adornis/chemistry/directives/css';
import { XSnackbar } from '@adornis/chemistry/elements/components/x-snackbar';
import { XDialog } from '@adornis/dialog/x-dialog';
import '@adornis/digitale-helden-shared/client/theme/buildify/d-buildify';
import { goTo } from '@adornis/router/client/open-href';
import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { distinctUntilChanged, filter, firstValueFrom, switchMap, timer } from 'rxjs';
import { getMarketingBuildifyExtensions } from '../../buildify/client/helpers';
import { GlobalComponent } from '../../db/GlobalComponent';
import { MarketingVisualizeBuildify } from '../../features/buildify/client/MarketingVisualizeBuildify';

@customElement('marketing-page-admin-edit-global')
export class MarketingPageAdminEditGlobal extends ChemistryLitElement {
  @property({ attribute: false }) identifier = new RXController<Maybe<string>>(this, undefined);
  @property({ attribute: false }) additionalExtensions = new RXController(this, []);
  @property({ attribute: false }) private readonly _extensions = new RXController(
    this,
    getMarketingBuildifyExtensions(),
  );
  @state() private readonly _globalComponent = new RXController(
    this,
    this.identifier.observable.pipe(
      filter(Boolean),
      distinctUntilChanged(),
      switchMap(identifier => GlobalComponent.getByID<GlobalComponent>(identifier)(GlobalComponent.allFields)),
    ),
  );

  override disconnectedCallback(): void {
    super.disconnectedCallback();
    this._globalComponent.value?.revert();
  }

  override render() {
    if (!this._globalComponent.value || !this._extensions.value) return nothing;
    const extensions = [...this._extensions.value, ...this.additionalExtensions.value];

    return html`
      <d-flex horizontal space-between crossaxis-center ${css({ padding: this.spacing.lg })}>
        <d-button mode="outline" icon="arrow-left" @click=${() => goTo('/admin')}> zurück </d-button>
        <d-button
          @click=${async () => {
            await XDialog.waitFor(Promise.all([this._globalComponent.value?.save(), firstValueFrom(timer(1000))]))
              .then(res => {
                return XSnackbar.show('Gespeichert!');
              })
              .catch(err => {
                console.log(err);
                return XSnackbar.show('Seite konnte nicht gespeichert werden.');
              });
          }}
        >
          Speichern
        </d-button>
      </d-flex>
      ${MarketingVisualizeBuildify({
        value: this._globalComponent.value.content,
        entityData: this._globalComponent.value,
        mode: 'edit',
        getExtensions: () => Promise.resolve(extensions),
      })}
    `;
  }
}
